var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _circle, _path12, _path13, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDash1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 12.5,
    width: 39.1803,
    height: 39.1803,
    rx: 2.5,
    fill: "white",
    stroke: "#9A9FB0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.506 41.2225C24.7752 41.2225 25.8041 40.202 25.8041 38.9432C25.8041 37.6843 25.1254 36.8428 23.8561 36.8428C23.1471 36.8428 23.4571 37.6077 22.7988 38.2526C22.0938 38.9432 21.3889 38.7544 21.3889 39.31C21.3889 40.5689 22.2368 41.2225 23.506 41.2225Z",
    stroke: "url(#paint0_linear)",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.684 42.4822C19.6267 40.7199 19.2742 37.5478 20.684 36.4905C22.0939 35.4331 23.5037 34.7281 25.266 35.7855C27.0283 36.8429 28.0857 40.3675 26.3234 42.4822",
    stroke: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5061 41.2227C21.5143 41.2227 19.894 42.8251 19.894 44.8052H27.1135C27.1135 42.8251 25.4978 41.2227 23.5061 41.2227Z",
    stroke: "url(#paint2_linear)",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2224 23.6113C24.6888 23.6113 25.8776 22.4323 25.8776 20.9778C25.8776 19.5233 24.6888 18.3442 23.2224 18.3442C21.7559 18.3442 20.5671 19.5233 20.5671 20.9778C20.5671 22.4323 21.7559 23.6113 23.2224 23.6113Z",
    stroke: "url(#paint3_linear)",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2223 23.6113C20.9211 23.6113 19.0491 25.4628 19.0491 27.7505H27.3903C27.3903 25.4628 25.5235 23.6113 23.2223 23.6113Z",
    stroke: "url(#paint4_linear)",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0901 20.459H46.8934",
    stroke: "#27282B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0901 37.377H46.8934",
    stroke: "#27282B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0901 23.2788H42.6639",
    stroke: "#27282B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0901 40.1968H42.6639",
    stroke: "#27282B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0901 26.0984H38.4344",
    stroke: "#27282B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0901 43.0164H38.4344",
    stroke: "#27282B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45.1311,
    cy: 45.1313,
    r: 9.36885,
    fill: "white",
    stroke: "#9A9FB0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2952 47.0005L48.7751 40.5206L50.2704 42.0159L43.7906 48.4958L41.7968 48.9943L42.2952 47.0005Z",
    stroke: "url(#paint5_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3115 47.2458C42.7815 47.1283 43.7214 47.1753 43.7214 48.3032",
    stroke: "url(#paint6_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 21.3889,
    y1: 39.0327,
    x2: 25.4733,
    y2: 40.195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4164DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#587CF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 19.7542,
    y1: 38.8723,
    x2: 26.6407,
    y2: 40.8852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4164DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#587CF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 19.894,
    y1: 43.0139,
    x2: 25.3483,
    y2: 46.1168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4164DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#587CF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 20.5671,
    y1: 20.9778,
    x2: 25.4796,
    y2: 22.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4164DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#587CF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 19.0491,
    y1: 25.6809,
    x2: 25.3508,
    y2: 29.2659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4164DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#587CF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 41.7968,
    y1: 48.9943,
    x2: 47.8704,
    y2: 50.1271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4164DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#587CF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 42.3115,
    y1: 47.7525,
    x2: 43.5585,
    y2: 48.2032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4164DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#587CF4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDash1);
export default __webpack_public_path__ + "static/media/dash1.fef8fe28786f8ca96cc2c590bc984558.svg";
export { ForwardRef as ReactComponent };